import { render } from "./PrivacyPolicyCheckbox.vue?vue&type=template&id=2d52a2a0&scoped=true"
import script from "./PrivacyPolicyCheckbox.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyCheckbox.vue?vue&type=script&lang=js"

import "./PrivacyPolicyCheckbox.vue?vue&type=style&index=0&id=2d52a2a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d52a2a0"]])

export default __exports__